"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var WickedApiClient_1 = require("./WickedApiClient");
var DTOAdvertisementEx = /** @class */ (function (_super) {
    __extends(DTOAdvertisementEx, _super);
    function DTOAdvertisementEx() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(DTOAdvertisementEx.prototype, "mainImage", {
        get: function () {
            return this.images && this.images.length > 0 ? this.images[0] : undefined;
        },
        enumerable: true,
        configurable: true
    });
    DTOAdvertisementEx.fromJS = function (data) {
        data = typeof data === "object" ? data : {};
        var result = new DTOAdvertisementEx();
        result.init(data);
        return result;
    };
    return DTOAdvertisementEx;
}(WickedApiClient_1.DTOAdvertisement));
exports.DTOAdvertisementEx = DTOAdvertisementEx;
